/*
Lalitha 12/19/2022 3075154998 Added Added Search Data Manager Record Form
Lalitha 12/20/2022  3075154998 Added Created Date Data Manager Form
Sohel  12/21/2022 3075154998 Added record Type Validation and dropdown values.
Lalitha 12/21/2022  3075154998 Integrated search Api
Sohel  12/29/2022 3075154998 Added Export Manager Record Screen
Suresh Peddavoora 01/04/2022 3075154998 Fixed DialogBox Spacing Alignments
dilip 01/09/2023 3075154998 Added search data local storage
Suresh Peddavoora  01/11/2023 3075154998 Fixed Responsive issues for Textfields
Suresh Peddavoora  01/13/2023 3075154998 Fixed Spacing issues for Textfields and Table
Lalitha 01/17/2023 3075154998 fixed by dafault to Upper Case in code
Ashraf 01/27/2023 3075154998 added new fields
Suresh Peddavoora  01/31/2023 3075154998 Fixed Column Alignments issues for Textfields
Sohel 01/08/2023 2701335619 Implemented Usage Functionality
Dilip 02/09/2023 2701335619 added creted for field and created by fields
Guru Prasad 02/14/2023 2701335619 Fixed alignments fixes
Raghu 02/23/2023 2701335619 added new class for input feilds and buttons
Raghu 02/27/2023 2701335619 fixed ui alignments
Raghu 03/14/2023 2701335619 fixed ui alignments
T Santosh Kumar 15/03/2023 2701335619 Responsive UI Changes
Prakash 03/17/2023 2701335619 fixed alignments in responsive.
Prakash 03/20/2023 2701335619 fixed alignments issues.
Prakash 03/28/2023 2701335619 fixed inputfiled alignments issue.
Akhila 06/08/2023 2701335619 title label placeholder name change
Akhila 06/08/2023 2701335619 rearrange the column and form fields
Sohel 11/12/2023 2701335619 code field removed upper case
Sohel 12/12/2023 2701335619 label name change code to name 
*/
import {Button, FormHelperText, TextField} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useEffect, useState, useContext} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {getDropDownData} from '../../../../../redux/reducers/BRE/AddRecordFormat';
import SearchDMRecordTable from './SearchDMRecordTable';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import * as Yup from 'yup';
import {createForOptions, createdByOptions} from '../../../../../util/CreatedByForOptions';
const recordType = [{value: 'Data Export'}, {value: 'Header'}, {value: 'Footer'}];
const StatusOptions = [
  {key: 'Y', value: 'Draft'},
  {key: 'N', value: 'Completed'},
];

const SearchDataManagerRecord = ({
  setValue,
  isMapRecordGroup,
  setEditExisting,
  dmTempRecordAccess,
  setDataManagerRecordData = () => {},
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {createdForData, createdByData} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const categoryData = [
    {
      categoryCode: 'CO',
      categoryName: 'Core',
    },
  ];

  const promptOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];

  const initialState = {
    code: '',
    recordDescription: '',
    recordType: '',
    isDraft: '',
    createdDate: null,
    category: '',
    includeAudit: '',
    createdFor: '',
    createdBy: '',
  };
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const handleSubmit = (values) => {
    sessionStorage.setItem('EMRecord', JSON.stringify(values));
    setSearchData(values);
    setSubmit(true);
  };

  useEffect(() => {
    dispatch(getDropDownData());
    setEditExisting && setEditExisting(false);
  }, []);

  useEffect(() => {
    dispatch(fetchCreatedForDropDownData('exporttemplaterecord'));
    dispatch(fetchCreatedByDropDownData('exporttemplaterecord'));
  }, [dispatch]);

  const onClear = () => {
    const data = {
      code: '',
      recordDescription: '',
      recordType: '',
      isDraft: '',
      createdDate: null,
      category: '',
      includeAudit: '',
      createdFor: '',
      createdBy: '',
    };
    setSearchData(data);
    sessionStorage.removeItem('EMRecord');
  };
  const EMRecordSessionStorage = JSON.parse(sessionStorage.getItem('EMRecord'));

  return (
    <>
      <div className={isMapRecordGroup ? `col-12` : ``}>
        <h2 className="search-title">Export Template Search</h2>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={EMRecordSessionStorage ? EMRecordSessionStorage : initialState}
          enableReinitialize
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              handleBlur,
              handleChange,
              handleReset,
              handleSubmit,
              setFieldValue,
              touched,
              errors,
            } = props;
            return (
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="form-row new-standard-textfields">
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-4 account-guarantor`}>
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Enter Export Template Record Name"
                      margin="dense"
                      name="code"
                      variant="outlined"
                      value={values?.code}
                      label="Export Template Record Name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      fullWidth
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-4 form-group account-guarantor">
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Enter Export Template Description"
                      margin="dense"
                      name="recordDescription"
                      value={values.recordDescription}
                      variant="outlined"
                      label="Export Template Description"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      fullWidth
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-xl-2 col-lg-3 form-group account-guarantor">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="recordType"
                      id="recordType"
                      size="small"
                      value={values.recordType}
                      options={recordType}
                      getOptionLabel={(option) => {
                        return option?.value ? option?.value : '';
                      }}
                      autoHighlight
                      onChange={(e, value) => {
                        setFieldValue('recordType', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Record Type"
                            placeholder="Select Record Type"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-xl-2 col-lg-3 form-group account-guarantor">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      name="includeAudit"
                      id="includeAudit"
                      size="small"
                      options={promptOptions}
                      value={values.includeAudit}
                      getOptionLabel={(option) => {
                        return option && option?.value && option?.key ?
                          `${option?.key + ' - ' + option?.value}` :
                          option?.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('includeAudit', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Include Audit"
                            placeholder="Select Include Audit"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div
                    className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-2 form-group account-guarantor`}
                  >
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="createdFor"
                      id="createdFor"
                      size="small"
                      value={values.createdFor}
                      options={createdForData}
                      getOptionLabel={(option) => {
                        return option && option?.userLoginName ? option?.userLoginName : '';
                      }}
                      renderOption={(option) => {
                        return createForOptions(option);
                      }}
                      onChange={(e, value) => {
                        setFieldValue('createdFor', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Created For"
                            placeholder="Select Created For"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group account-guarantor">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="createdBy"
                      id="createdBy"
                      size="small"
                      value={values.createdBy}
                      options={createdByData}
                      getOptionLabel={(option) => {
                        return option && option?.userLoginName ? option?.userLoginName : '';
                      }}
                      renderOption={(option) => {
                        return createdByOptions(option);
                      }}
                      onChange={(e, value) => {
                        setFieldValue('createdBy', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Created By"
                            placeholder="Select Created By"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div
                    className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-2 start-enddate account-guarantor`}
                  >
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        className={` ${classes.labelName}`}
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        value={values.createdDate}
                        name="createdDate"
                        onBlur={handleBlur}
                        inputVariant="outlined"
                        helperText=""
                        label="Date Created"
                        error={Boolean(touched?.createdDate && errors?.createdDate)}
                        onChange={(val) => {
                          setFieldValue('createdDate', val);
                        }}
                        autoOk
                        margin="dense"
                      />
                    </MuiPickersUtilsProvider>
                    <FormHelperText variant="outlined">
                      {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                    </FormHelperText>
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-2 account-guarantor`}>
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="isDraft"
                      id="isDraft"
                      size="small"
                      options={StatusOptions}
                      required
                      value={values.isDraft}
                      getOptionLabel={(option) => {
                        return option && option?.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('isDraft', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Status"
                            placeholder="Select Status"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-xl-2 col-lg-3 form-group account-guarantor">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                        popper: classes.popper,
                      }}
                      name="category"
                      id="category"
                      size="small"
                      value={values.category}
                      options={categoryData?.length > 0 ? categoryData : []}
                      getOptionDisabled={(option) => option.categoryCode === ''}
                      getOptionLabel={(option) => {
                        return option && option.categoryName ?
                          option.categoryCode === null ?
                            option.categoryName :
                            option.categoryCode + ' - ' + option.categoryName :
                          '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('category', value);
                      }}
                      placeholder="Select Category"
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            name="category"
                            label="Category"
                            placeholder="Select Category"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-md-12 col-lg-3 col-xl-12 form-group">
                    <div className="new-standard-textfields d-flex justify-content-md-center justify-content-lg-center">
                      <Button
                        variant="outlined"
                        className={`mr-1 reset-btn`}
                        onClick={() => {
                          handleReset();
                          setSubmit(true);
                          onClear();
                        }}
                      >
                        Reset
                      </Button>
                      <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
        <SearchDMRecordTable
          setValue={setValue}
          searchData={searchData}
          submit={submit}
          setEditExisting={setEditExisting}
          setSubmit={setSubmit}
          isMapRecordGroup={isMapRecordGroup}
          dmTempRecordAccess={dmTempRecordAccess}
          setDataManagerRecordData={setDataManagerRecordData}
        />
      </div>
    </>
  );
};
export default SearchDataManagerRecord;
